module.exports = "<div class=title>{{title}}</div> <div class=charge>{{valuePrefix}}<span [countTo]=count></span></div> ";